"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminLeaderboardContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.adminLeaderboardContract = c.router({
    awardPointsToUserForAction: {
        method: 'POST',
        path: '/award-points',
        body: zod_1.z.object({
            playerId: zod_1.z.string(),
            action: models_1.ZLeaderboardAction,
        }),
        responses: {
            200: zod_1.z.object({
                points: zod_1.z.number(),
            }),
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
}, {
    pathPrefix: '/admin',
    strictStatusCodes: true,
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=leaderboard.admin.contract.js.map